import React from "react";
import { Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CrewDashboardPage from "../components/common/pages/AgentDashboard";
// import TilePage from "../components/common/pages/TilesPage";
import TilesDetailsPage from "../components/common/pages/TilesDetailsPage";
import ChatLayout from "../components/common/templates/ChatLayout";
import PageNotFound from "../components/common/pages/PageNotFound";
import "../components/static/css/Sidebar.css";
import CrewFormPage from "../components/common/pages/CrewFormPage";
import CrewEditFormPage from "../components/common/pages/CrewEditFormPage";
import CrewDetailsPage from "../components/common/pages/CrewDetailsPage";
import SpaceFormPage from "../components/common/pages/SpaceFormPage";
import SpaceScreenPage from "../components/common/pages/SpaceScreenPage";
import AgentFormPage from "../components/common/pages/AgentFormPage";

import DashboardDetailsPage from "../components/common/pages/DashboardDetailsPage";


import TrainingRecordsPage from "../components/common/pages/TrainingRecordsPage";
import KnowledgePage from "../components/common/pages/KnowledgePage";
import RegisterPage from "../components/common/pages/RegisterPage";
import LoginPage from "../components/common/pages/LoginPage";
import ForgotPasswordPage from "../components/common/pages/ForgotPasswordPage";
import UserPage from "../components/common/pages/UserPage";

import ConfigurationPage from "../components/common/pages/ConfigurationPage";
import Permission from "../components/common/molecules/Permission";
import RolePage from "../components/common/pages/RolePage";

import PermissionPage from "../components/common/pages/PermissionPage";
import Flows from "../components/common/pages/Flows";
import CreateFlow from "../components/common/molecules/CreateFlow";
import Frequency from "../components/common/pages/Frequency";
import Finetune from "../components/common/pages/FineTune";
import FineTuneOverview from "../components/common/pages/FineTuneOverview";
import Logs from "../components/common/pages/Logs";
import LogsDetails from "../components/common/pages/LogsDetails";
import RoleDetails from "../components/common/pages/RoleDetails";
import Output from "../components/common/pages/Output";
import KnowledgeHolders from "../components/common/pages/KnowledgeHolders";

import ChatLayoutClaude from "../components/common/templates/ChatLayoutClaude";
import ChatLayoutMistral from "../components/common/templates/ChatLayoutMistral";
import AccessDenied from "../components/common/atoms/AccessDenied";
import Core from "../components/common/pages/Core";
import ManageUsers from "../components/common/pages/ManageUsers";
import CrewConfiguration from "../components/common/atoms/CrewConfiguration";
import BuildScreen from "../components/common/atoms/BuildScreen";
import SpaceConfig from "../components/common/atoms/SpaceConfig";
import OrganizationForm from "../components/common/molecules/OrganizationForm";
import { PartnerTab } from "../components/common/molecules/PartnerTab";
import ManagePartnerCompanys from "../components/common/pages/ManagePartnerCompanys";
import ManageCompany from "../components/common/pages/ManageCompanies";
import AccessControl from "../components/common/molecules/AccessControl";

const AppRoutes: React.FC = () => {
  return (
    <>
      <ToastContainer />
      <Routes>
        {/* Auth */}

        <Route path="/register" element={<RegisterPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forget-password" element={<ForgotPasswordPage />} />

        {/* User */}
        <Route path="/user-page/:pageContext/:id" element={<UserPage />} />

        {/* <Route path="dashboard" element={<TilePage />} /> */}

        <Route path="/" element={<DashboardDetailsPage />} />
        
        <Route path="/:category" element={<TilesDetailsPage />} />

        {/*company*/}
        <Route path="/create-company" element={<OrganizationForm />} />
        <Route path="/partner-tab" element={<PartnerTab/>} />
        {/* crew */}
        <Route path="/add_crew" element={<CrewFormPage />} />
        <Route path="/edit_crew/:id" element={<CrewEditFormPage />} />
        <Route path="/crew_detail/:id" element={<CrewDetailsPage />} />
        
        {/* crew-screen */}

        <Route path="/crew-configurations/:id" element={< CrewConfiguration/>}/>
        <Route path="/crew-build/:id" element={<BuildScreen/>}/>

        {/* <Route path = "/crew/:id" element = {<CrewEditForm/>}/> */}

        {/* space */}
        <Route path="/add_space" element={<SpaceFormPage />} />
        <Route path="/ai_space/:id" element={<ChatLayout />} />
        <Route path="/ai_space/:id/section" element={<ChatLayout />} />

        <Route
          path="/ai_space/:id/section_claude"
          element={<ChatLayoutClaude />}
        />
        <Route 
          path="/ai_space/:id/section_mistral"
          element={<ChatLayoutMistral />}
        />

        <Route path="/space/:id" element={<SpaceScreenPage />} />
        <Route path="/space_detail/:id" element={<SpaceFormPage />} />
        <Route path="/knowledge_hub_user/:id" element={<KnowledgeHolders />} />

        {/* space-screen */}
        <Route path="/space-config/:id" element={<SpaceConfig/>}/>
      

        {/* agent */}
        <Route path="/agents/:id" element={<CrewDashboardPage />} />
        <Route path="/add_agent/:id" element={<AgentFormPage />} />
        <Route path="/edit_agent/:id/:agentId" element={<AgentFormPage />} />
        <Route path="/agent_detail/:id/:agentId" element={<AgentFormPage />} />

        {/* training */}
     
        <Route path="/training/:id" element={<TrainingRecordsPage />} />
        <Route path ='/trained-crews/:id' element={<TrainingRecordsPage/>}/>
        <Route path="/training-crew/:id/upload" element={<KnowledgePage />} />
        <Route path="/training-space/:id/upload" element={<KnowledgePage />} />

        {/*crew-Analyze */}
        <Route path="/crew-analyzed-records/:id" element={<TrainingRecordsPage/>}/>
        <Route path="/crew-analyze/:id/upload" element = {<KnowledgePage/>}/>
  
       {/* crew-prepare */}
        <Route path="/crew-prepared-records/:id" element={<TrainingRecordsPage/>}/>
        <Route path="/crew-prepare/:id/upload" element = {<KnowledgePage/>}/>



        {/*space-Analyze */}

        <Route path="/space-analyzed-records/:id" element={<TrainingRecordsPage/>}/>
        <Route path="/space-analyze/:id/upload" element = {<KnowledgePage/>}/>
 

        {/*space-prepare */}

        <Route path="/space-prepared-records/:id" element={<TrainingRecordsPage/>}/>
        <Route path="/space-prepare/:id/upload" element = {<KnowledgePage/>}/>

        {/* Output */}

        {/* flows */}

        <Route path="/flows/:id" element={  <Flows /> } />
        <Route path="/create_flows/:id" element={<CreateFlow />} />
        <Route path="/edit-flow/:id/flow/:flowId" element={<CreateFlow />} />

        {/* frequency */}
        <Route path="/frequency/:id" element={<Frequency />} />

        {/* Expected output */}
        {/* <Route path="/response/:id" element={<Finetune />} /> */}
        <Route path="/response/:id" element={<Output />} />
        <Route path="/finetune_response/:id" element={<Finetune />} />
        <Route path="/space-finetune_response/:id" element={<Finetune />} />
        <Route
          path="/finetune_overview/:taskId"
          element={<FineTuneOverview />}
        />

        {/* configuration */}
        <Route path="/configuration" element={<ConfigurationPage />} />
        <Route path="/role_details" element={<RoleDetails />} />
        <Route path="/permission" element={<PermissionPage />} />
        <Route path="/roles" element={<RolePage />} />
        <Route path="/edit_role/:id" element={<RolePage />} />

        {/* aaccess-denied */}
        <Route path="/access-denied" element={<AccessDenied />} />

        {/* core */}
        <Route path="/core" element={<Core />} />

       {/* manage-company */}

       <Route path="/manage-companies" element={<ManageCompany/>}/>
        {/* manage-users */}
        <Route path="/manage-users" element = {<ManageUsers/>}/>
        <Route path="/manage-partner-company" element={<ManagePartnerCompanys/>}/> 
        {/* logs */}
        <Route path="/logs/:id" element={<Logs />} />
        <Route path="/logs_details/:id" element={<LogsDetails />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </>
  );
};

export default AppRoutes;
